import { Fragment, h } from "preact";
import s from "./defaultPicker.module.css";
import { useDefaultPicker } from "./useDefaultPicker";
import { useAppContext } from "../../../../../../contexts";
import { iconInfoSectionArrow } from "../../../../../../assets";
import Item from "./AttendanceRegion/Item";
import AttendanceRegion from "./AttendanceRegion";

const DefaultPicker = props => {
    // Destructured component props
    const {
        attendanceType,
        errors,
        selectedValue,
        handleSelectedValue,
        hasSubmitted,
        handleErrors,
        items, 
        errorMessage,
        attendance
    } = props;

    // Component logic data
    const componentProps = useDefaultPicker({
        attendanceType,
        handleSelectedValue,
        handleErrors,
        items
    });

    // Destructured component logic data
    const {
        isOpen,
        handleOpen,
        handleChange
    } = componentProps;

    // The main content variable
    const content = attendance.regions.map(region => {
        return (
            <AttendanceRegion
                key={region.id}
                region={region}
                hasSubmitted={hasSubmitted}
                errors={errors}
                errorMessage={errorMessage}
                handleChange={handleChange}
                selectedValue={selectedValue}
                openedRegionID={isOpen}
                handleOpen={handleOpen}
            />
        )
    });

    return (
        <Fragment>
            {content}
        </Fragment>
    )
}

export default DefaultPicker;
